export default __webpack_public_path__ + "static/Inter-ExtraBold-55189ddfcadbb76776b5b6e221e5a5f6.ttf";